<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Spinner from "../components/spinner.svelte";   
    import Modal from "../components/modal.svelte";
    import LogDetails from "../components/logdetails.svelte";
    import DataTable from "../../components/data-table.svelte";
    import Button from "../components/button.svelte";

    export let guid = "";
    export let actionType = "";

    let pendingTransferRequestsMadeBy = [];
    let pendingTransferRequestsMadeTo = [];
    let isPageLoading = true;
    let showModal = false;
    let modalMessage = "";
    let isButtonLoading = false;
    
    let columnDefs = [{ type: 'date-euro', targets: [1] }];

    onMount(async () => {  
        if ((guid != "" && guid != null) && (actionType != "" || actionType != null))
            await updatePendingTransferRequests(guid, actionType);
        else await getPendingTransferRequests();
    });

    const getPendingTransferRequests = async () => {
        isPageLoading = true;
        let resp = await wrappedFetch(
            "/api/reports/GetPendingTransferRequests",
            {
                method: "post",
            }
        );
        let pendingTransferRequests = await resp.json();
        pendingTransferRequestsMadeBy = pendingTransferRequests.transfersRequested;
        pendingTransferRequestsMadeTo = pendingTransferRequests.transfersRequestsReceived;
        isPageLoading = false;
    };

    const updatePendingTransferRequests = async (guid, action) => {
        isButtonLoading = true;
        modalMessage = "";
        let resp = await wrappedFetch(
            `/api/reports/GetPendingTransferRequests?guid=${guid}&actionType=${action}`,
            {
                method: "post",
            }
        );
        let pendingTransferRequests = await resp.json();
        let response = pendingTransferRequests.response;
        if (response && response.message != "") {
            showModal = true;
            modalMessage = response.message;
        }
        pendingTransferRequestsMadeBy = pendingTransferRequests.transfersRequested;
        pendingTransferRequestsMadeTo = pendingTransferRequests.transfersRequestsReceived;
        isButtonLoading = false;
    };

</script>

<style>
    .card-title {
        background-color: #136f63;
        color: white;
        padding:0.5rem 0.5rem 0 0.5rem;
        margin-bottom:0px;
    }
    /* .card-title .material-icons.md1::before {
        content: "keyboard_arrow_up";
    }
    .card-title.collapsed .material-icons.md1::before {
        content: "keyboard_arrow_down";
    } */
    .btn {
        color: #2e817d;
        border: 1px solid #2e817d;
    }
</style>

<svelte:head>
    <title>Import Logs | Staff Pending Requests | Wavenet Nimbus </title>
</svelte:head>

{#if isPageLoading}
    <Spinner/>
{:else}
    <LogDetails backURL="/app/import/logs">
        <div slot="title"><h1>Staff Pending Requests</h1>
            <p>These are requests to transfer users between schools which need to be approved for the transfer to take place.</p>
        </div>
        <div slot="content">  
            <div class="card">
                <a
                    class="card-title d-block"
                    data-toggle="collapse"
                    href="#type1"
                    aria-expanded="true"
                    aria-controls="type1">
                    <h5 style="float: left;">Transfer Requests Made</h5>
                    <i
                        style="float: right; font-weight: bold !important;"
                        class="material-icons md1" />
                </a>

                <div id="type1" class={pendingTransferRequestsMadeBy.length > 0 ?"card-body show":"card-body with-table show"}>
                    <DataTable info={false} searching={false} {columnDefs} message="No transfer requests made" DataLength={pendingTransferRequestsMadeBy.length}>
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    class="sorting_asc"
                                    aria-sort="ascending">
                                    Requestor
                                </th>
                                <th>On</th>
                                <th>Name</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Type</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each pendingTransferRequestsMadeBy as r}
                                <tr>
                                    <td>{r.reqName}</td>
                                    <td>{r.requestDate || ''}</td>
                                    <td>{r.transferName}</td>
                                    <td>{r.oldEstab}</td>
                                    <td>{r.newEstab}</td>
                                    <td>{r.actionType}</td>
                                    <td>{r.respType}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </DataTable>
                </div>
            </div>
            <br />
            <div class="card">
                <a
                    class="card-title d-block"
                    data-toggle="collapse"
                    href="#type2"
                    aria-expanded="true"
                    aria-controls="type2">
                    <h5 style="float: left;">Transfer Requests Received</h5>
                    <i
                        style="float: right; font-weight: bold !important;"
                        class="material-icons md1" />
                </a>

                <div id="type2" class={pendingTransferRequestsMadeTo.length > 0 ?"card-body show":"card-body with-table show"}>
                    <DataTable info={false} searching={false} {columnDefs} message="No transfer requests received" DataLength={pendingTransferRequestsMadeTo.length}>
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    class="sorting_asc"
                                    aria-sort="ascending">
                                    Requestor
                                </th>
                                <th>On</th>
                                <th>Staff</th>
                                <th>From</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each pendingTransferRequestsMadeTo as r}
                                <tr>
                                    <td>{r.reqName}</td>
                                    <td>{r.requestDate || ''}</td>
                                    <td>{r.transferName}</td>
                                    <td>{r.oldEstab}</td>
                                    <td>{r.actionType}</td>
                                    <td>{r.respType}</td>
                                    <td>
                                        {#if r.respType == 'Pending'}
                                        <Button buttonText={"Approve"} buttonClass={"btn-grey btn-sm"} bind:isLoading={isButtonLoading} buttonStyle={"width:82px;height:35px;"}  on:click={() => updatePendingTransferRequests(r.guid, 'approve')}/>
                                            <!-- <button
                                                class="btn btn-grey btn-sm"
                                                style="height:35px;"
                                                href="javascript:;"
                                                on:click={() => updatePendingTransferRequests(r.guid, 'approve')}>
                                                Approve
                                            </button> -->
                                            <Button buttonText={"Deny"} buttonClass={"btn-grey btn-sm"} bind:isLoading={isButtonLoading} buttonStyle={"width:82px;height:35px;"}  on:click={() => updatePendingTransferRequests(r.guid, 'deny')}/>
                                            <!-- <button
                                                class="btn btn-grey btn-sm"
                                                style="height:35px;"
                                                href="javascript:;"
                                                on:click={() => updatePendingTransferRequests(r.guid, 'deny')}>
                                                Deny
                                            </button> -->
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </DataTable>
                </div>
            </div>
        </div>
    </LogDetails>
{/if}

<Modal bind:showModal sizeClass="modal-lg">
    <div slot="header">
        <h4 class="title"><span class="info fas fa-info-circle" /> Info</h4>
    </div>
    <div slot="content">
        {@html modalMessage}
    </div>
</Modal>
